import { render } from "./LegAddressDialog.vue?vue&type=template&id=4156f4b6&scoped=true"
import script from "./LegAddressDialog.vue?vue&type=script&lang=js"
export * from "./LegAddressDialog.vue?vue&type=script&lang=js"

import "./LegAddressDialog.vue?vue&type=style&index=0&id=4156f4b6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4156f4b6"]])

export default __exports__